import { NgModule } from '@angular/core';
import { FocusDirective } from './focus.directive';
import { FocusService } from './focus.service';

/**
 * Module providing focus management utilities for Angular applications.
 *
 * @remarks
 * This module exports the {@link FocusDirective} for declarative template-based focus
 * control and provides the {@link FocusService} for programmatic focus management.
 * Both the directive and service work together to handle element focus with built-in
 * throttling and focusability validation.
 *
 * Import this module in any feature module that needs to use the `[bbFocus]` directive
 * or inject the `FocusService` directly.
 *
 * @example
 *
 * ```typescript
 * import { NgModule } from '@angular/core';
 * import { CommonModule } from '@angular/common';
 * import { FocusModule } from '@backbase/ui-ang/focus';
 * import { SearchComponent } from './search.component';
 *
 * @NgModule({
 *   imports: [CommonModule, FocusModule],
 *   declarations: [SearchComponent],
 * })
 * export class SearchFeatureModule {}
 * ```
 */
@NgModule({
  declarations: [FocusDirective],
  providers: [FocusService],
  exports: [FocusDirective],
})
export class FocusModule {}
